import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import { ShortWrapper } from '../elements';

export const Wrapper = styled(ShortWrapper)`
  background: #ffffff;
  min-height: 120px;
`;

export const ProfileWrapper = styled(Wra16A)`
  width: 100%;
  position: relative;
  z-index: 1;
  background: #ffffff;
`;
